let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bHtFa")).then(() => parcelRequire('j3Mzb'));